import {
	AppBar,
	Box,
	Button,
	Grid2,
	IconButton,
	Typography,
} from '@mui/material';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';

interface TopNavigationBarProps {
	onClickLogo?: () => void;
	onClickLogout: () => void;
}

function TopNavigationBar(props: TopNavigationBarProps) {
	const brand = (
		<Grid2 container alignItems="center" gap={1.25}>
			<Box
				sx={{
					width: 32,
					height: 32,
					borderRadius: '50%',
					backgroundColor: MAIN_THEME_COLOR,
					color: '#FFFFFF',
					display: 'grid',
					placeItems: 'center',
					fontSize: '12px',
					fontWeight: 700,
					letterSpacing: 0,
				}}>
				CM
			</Box>
			<Typography
				fontSize={{ xs: '16px', sm: '17px' }}
				fontWeight={700}
				color="#111B21"
				whiteSpace="nowrap">
				SenzMate Website Bot Conversation Manager
			</Typography>
		</Grid2>
	);

	return (
		<AppBar
			position="fixed"
			sx={{
				backgroundColor: '#FFFFFF',
				color: '#111B21',
				borderBottom: '1px solid #E9EDEF',
				zIndex: theme => theme.zIndex.drawer + 1,
			}}
			elevation={0}>
			<Grid2
				container
				sx={{ px: { xs: 1.25, sm: 2 } }}
				alignItems={'center'}
				justifyContent={'space-between'}
				height={'60px'}>
				{props.onClickLogo ? (
					<Grid2 container alignItems="center" gap={0.5}>
						<IconButton
							aria-label="Open navigation"
							onClick={props.onClickLogo}
							sx={{ color: '#54656F' }}>
							<Box
								component="span"
								sx={{
									width: 18,
									height: 14,
									display: 'block',
									borderTop: '2px solid currentColor',
									borderBottom: '2px solid currentColor',
									position: 'relative',
									'&::after': {
										content: '""',
										position: 'absolute',
										left: 0,
										right: 0,
										top: 5,
										borderTop: '2px solid currentColor',
									},
								}}
							/>
						</IconButton>
						{brand}
					</Grid2>
				) : (
					brand
				)}
				<Button
					sx={{
						color: '#54656F',
						minWidth: 0,
						px: { xs: 1, sm: 1.5 },
						'&:hover': {
							backgroundColor: '#F0F2F5',
							color: MAIN_THEME_COLOR,
						},
					}}
					onClick={props.onClickLogout}>
					Log out
				</Button>
			</Grid2>
		</AppBar>
	);
}

export default TopNavigationBar;
